export default __webpack_public_path__ + "static/media/tender4.dd519a25.png";